<script>
export default {
  name: "CrmRedeemNowCard",
  props: {
    item: {
      type: Object,
      required: true
    },
    dataTest: {
      type: String,
      required: true
    },
    showExpiration: {
      type: Boolean,
      default: false
    }
  },
  emits: ["select"],
  computed: {
    image() {
      return this.item.image_url || this.handleImageSrc;
    },
    title() {
      return (
        this.item.product_name ||
        this.item.coupon_language?.[0]?.name ||
        this.item.privilege_language?.[0]?.name ||
        this.item.privilege_name ||
        this.item.name ||
        "-"
      );
    },
    expirationDate() {
      if (!this.item.expired_date) return "-";
      return this.$moment(this.item.expired_date).format("DD MMM YY");
    }
  }
};
</script>

<template>
  <button
    type="button"
    class="crm-redeem-now-card"
    :data-test="dataTest"
    @click="$emit('select', item)"
  >
    <c-img-lazy :src="image" class="crm-redeem-now-card__image" />
    <span class="crm-redeem-now-card__body">
      <span class="crm-redeem-now-card__title">
        {{ title }}
      </span>
      <span
        v-if="showExpiration"
        class="crm-redeem-now-card__expiration"
        :data-test="`${dataTest}-expiration`"
      >
        <span
          class="crm-redeem-now-card__expiration-dot"
          aria-hidden="true"
        ></span>
        {{ $t("expired") }} {{ expirationDate }}
      </span>
      <span v-else class="crm-redeem-now-card__points">
        <span
          class="crm-summary__icon"
          :style="{ '--icon-url': `url(/svg/gift-02.svg)` }"
          aria-hidden="true"
        ></span>
        {{ numeralFormat(item.point_used || 0) }}
      </span>
      <c-btn
        variant="outline-primary"
        class="mt-1 f-helper py-1 mx-auto"
        autoWidth
        size="small"
      >
        {{ $t("reward_redeem_now") }}
        <!-- <font-awesome-icon icon="chevron-right" class="ml-2"></font-awesome-icon
      > -->
      </c-btn>
    </span>
  </button>
</template>

<style lang="scss" scoped>
.crm-redeem-now-card {
  display: flex;
  width: 180px;
  flex: 0 0 180px;
  flex-direction: column;
  overflow: hidden;
  padding: 0;
  border: 0;
  // border-radius: 14px;
  // background: #f8edef;
  color: #111;
  cursor: pointer;
  font: inherit;
  text-align: left;
  box-shadow: var(--crm-box-shadow);
}

.crm-redeem-now-card__image {
  width: 100%;
  // height: 136px;
  background: #f4f4f4;
}

.crm-redeem-now-card__image :deep(.v-img) {
  height: 100%;
}

.crm-redeem-now-card__body {
  display: flex;
  min-height: 85px;
  flex-direction: column;
  padding: 10px;
  height: 100%;
}

.crm-redeem-now-card__title {
  display: -webkit-box;
  overflow: hidden;
  color: #111;
  font-size: var(--font-body);

  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.crm-redeem-now-card__points {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: auto;
  // color: var(--primary-color);
  font-size: var(--font-body-lg);
  // font-weight: 900;
}
.crm-redeem-now-card__points .crm-summary__icon {
  color: var(--primary-color);
}

.crm-redeem-now-card__expiration {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-top: auto;
  color: var(--primary-color);
  font-size: var(--font-body-sm);
  font-weight: 800;
  white-space: nowrap;
}

.crm-redeem-now-card__expiration-dot {
  width: 8px;
  height: 8px;
  flex: 0 0 auto;
  border-radius: 50%;
  background: #ff2438;
  box-shadow: 0 0 7px rgba(255, 36, 56, 0.7);
}
</style>
